/**
 * WelcomeScreen - Initial welcome screen for the onboarding flow
 * Displays branding and introduces the platform
 */

import React from 'react';
import { useOnboarding } from '../../contexts/OnboardingContext';

const WelcomeScreen: React.FC = () => {
  const { setCurrentScreen } = useOnboarding();

  return (
    <div className="min-h-screen bg-kielis-glacier flex items-center justify-center">
      <div className="container mx-auto px-5 text-center">
        <h1 className="text-5xl font-bold text-kielis-navy mb-4">
          Kielis <span className="text-kielis-gold">✦</span>
        </h1>
        <p className="text-xl text-gray-600 mb-8">
          "Prep in 30 min, not 5 h."
        </p>
        <p className="text-base text-gray-600 mb-12 max-w-2xl mx-auto">
          AI-powered External Asset Manager platform designed for Swiss compliance.
          Streamline your client meetings with intelligent preparation and real-time assistance.
        </p>
        {/* TASK-659: this flow is FIRM SETUP (data sources & workspace), not
            client onboarding — prospects are onboarded from the dashboard
            ("Onboard a new prospective client") or the Clients page. */}
        <p className="text-sm text-gray-500 mb-8 max-w-xl mx-auto" data-testid="firm-setup-note">
          This is your firm's workspace setup (data sources and integrations). To onboard a
          prospective client, ask the dashboard assistant or use “Add Client” on the Clients page.
        </p>
        <button 
          className="bg-kielis-navy text-white px-8 py-4 rounded-lg text-lg font-medium hover:bg-opacity-90 transition-all"
          onClick={() => setCurrentScreen('data-hub')}
        >
          Get Started
        </button>
      </div>
    </div>
  );
};

export default WelcomeScreen;